require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-code-401-advanced-software-development-in-java-with-springmvc-and-android.json") })
        }
      }, "path---courses-code-401-advanced-software-development-in-java-with-springmvc-and-android");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-code-401-advanced-software-development-in-java-with-springmvc-and-android!./.cache/json/courses-code-401-advanced-software-development-in-java-with-springmvc-and-android.json
// module id = 1158
// module chunks = 231608221292675